"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationHotline',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: '',
        phoneStatus: ''
      },
      tableData: {
        data: [],
        total: 0
      }
    };
  },
  created: function created() {
    this.loadCurrent();
  },
  methods: {
    loadCurrent: function loadCurrent() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationHotlineListApi)(this.searchForm).then(function (data) {
        _this.tableData.data = data.list || [];
        _this.tableData.total = data.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadCurrent();
    },
    editPhone: function editPhone(row) {
      var _this2 = this;
      this.$prompt('售后热线', '编辑品牌热线', {
        inputValue: row.store && row.store.servicePhone || ''
      }).then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationHotlineSaveApi)({
          storeId: row.store.id,
          servicePhone: value
        }).then(function () {
          _this2.$message.success('热线已更新');
          _this2.loadCurrent();
        });
      }).catch(function () {});
    },
    clearPhone: function clearPhone(row) {
      var _this3 = this;
      this.$confirm('确认清空该门店热线？').then(function () {
        (0, _decoration.decorationHotlineActionApi)(row.store.id, {
          action: 'clear'
        }).then(function () {
          _this3.$message.success('已清空');
          _this3.loadCurrent();
        });
      }).catch(function () {});
    }
  }
};